import type { ReactNode } from 'react'

interface Props {
  title: ReactNode
  icon?: ReactNode
  children: ReactNode
  right?: ReactNode
}

export function Section({ title, icon, children, right }: Props) {
  return (
    <div className="rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="flex flex-row items-center justify-between gap-4 px-6 pt-6 pb-3">
        <div className="flex items-center gap-2">
          {icon && <div className="text-[#0A192F] dark:text-white">{icon}</div>}
          <h2 className="text-xl font-semibold leading-none text-slate-900 dark:text-white">
            {title}
          </h2>
        </div>
        {right}
      </div>
      <div className="px-6 pb-6">{children}</div>
    </div>
  )
}
